import { InboxPage } from '@/features/inbox/inbox-page'
import { LinkedInRequiredGate } from '@/components/linkedin-required-gate'

export default function InboxRoute() {
  return (
    <LinkedInRequiredGate
      featureName="Inbox"
      description="The inbox shows every conversation with your leads on LinkedIn — replies, AI rebuttals, and follow-ups. Connect an account to start receiving messages."
    >
      <InboxPage />
    </LinkedInRequiredGate>
  )
}
